import { Component, splitProps } from "solid-js";
import { cleanImagePath } from "../../API";

export enum Mode {
    crop = "crop"
}

export const Img : Component<any> = (props) => {
    const [local, others] = splitProps(props, ["src", "mode", "width", "height", "format"]);
    let src = local.src;
    let imageflow: string[] = [];
    if (local.mode) imageflow.push("mode=" + local.mode);
    if (local.width) imageflow.push("width=" + local.width);
    if (local.height) imageflow.push("height=" + local.height);
    if (local.format) imageflow.push("format=" + local.format);
    if (imageflow.length) src += "?" + imageflow.join("&");
    return (<img src={cleanImagePath(src)} {...others}></img>);
}